import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { HistorySortByEnum } from 'src/types';
import { historySortByAtom } from 'src/store';

type Props = {
  handleClick: () => void;
  includeLabel: boolean;
};

export const SortItems = ({ handleClick, includeLabel }: Props) => {
  const [sortBy, setSortBy] = useAtom(historySortByAtom);

  const { t } = useTranslation();

  return (
    <div className='z-20 flex min-w-[200px] max-w-min flex-col items-start justify-center rounded-lg bg-cloudGray font-secondary xs:min-w-[240px]'>
      {includeLabel && (
        <div className='inline-flex w-full justify-between p-3'>
          <span className='whitespace-nowrap font-secondary text-primary-dark'>
            {t('history.sort_by')}:
          </span>
        </div>
      )}
      <div
        className={`${includeLabel ? 'pb-4 pt-0' : 'py-4'} flex w-full flex-col items-start justify-center gap-2 pl-6 pr-4`}
      >
        {Object.keys(HistorySortByEnum).map((sort, i) => (
          <button
            key={`sort-${i}`}
            className={`w-full whitespace-nowrap py-0.5 text-left font-semibold transition-all ${
              sortBy === sort
                ? 'text-primary-dark hover:text-primary'
                : 'text-primary hover:text-primary-dark'
            }`}
            name={sort}
            onClick={(e) => {
              setSortBy(e.currentTarget.name as keyof typeof HistorySortByEnum);
              handleClick();
            }}
          >
            {t(`history.${sort}`)}
          </button>
        ))}
      </div>
    </div>
  );
};
